import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    name: '', // populated only after the Worker accepts the receiver
    environment: 'development',
    language: 'en',
    theme: 'dark',
        viewState: 'created', // 'created', 'loading', 'idle', 'launched', 'join', etc.
        status: 'initialized', // 'created', 'initialized', 'loaded', 'launched', 'playing', 'paused'
        creator: 'debug-user',
    games: [],
    players: [],
    room: { players: [], status: '', creator: '', game: {} },
    game: {
      id: 'debug-game',
      name: 'Debug Game Name',
      description: 'This is a mock description for testing the Join Page UI.',
      image: 'https://via.placeholder.com/800x450',
      minPlayers: 2,
      maxPlayers: 8,
      players: []
    }

  }),

  actions: {
        setName({ environment, name }) {
      this.environment = environment
      this.name = name
    },

    setRoom(roomData) {
      if (!roomData) return
      this.room = roomData
      // Sync the players list IDs for internal logic
      if (roomData.players) {
        this.players = roomData.players.map(p => p.id)
      }
    },

    initApp({ parameters, player, game }) {
      this.environment = parameters.environment
      this.language = parameters.language
      this.theme = parameters.theme
      this.creator = player.id
      this.game = game || { id: '', players: [] }
      this.viewState = 'loading'
      this.status = 'initialized'

      if (!this.players.includes(player.id)) {
        this.players.push(player.id)
      }
    },

    setGames(gameList) {
      this.games = gameList

      if (this.game?.id) {
        const match = gameList.find(g => g.id === this.game.id || g.game?.id === this.game.id)
        if (match) {
          this.game = match
                    this.viewState = 'join'
          this.status = 'launched'
          return
        } else {
          this.viewState = 'idle'
          this.status = 'idle'
        }
      } else {
        this.viewState = 'idle'
        this.status = 'idle'
      }
    },

    join({ userId }) {
      console.log('User', userId, 'wants to join')
      if (!this.players.includes(userId)) {
        this.players.push(userId)
      }
      if (!this.game.players.includes(userId)) {
        this.game.players.push(userId)
      }
    },

    leave({ userId }) {
      console.log('User', userId, 'leaves')
      this.players = this.players.filter(p => p !== userId)
      this.game.players = this.game.players.filter(p => p !== userId)
    },

    launchGame({ userId, game, room }) {
      // game:data.game,room :data.room,userId: data.userId
      console.log('Launching game...')
      if (room && room.creator) {
        this.creator = room.creator
        this.room = room
      } else if (userId) {
        this.creator = userId
      }
      this.game = room?.game || game
      this.viewState = 'join'
      this.status = 'launched'
    },

    idle({}) {
      // game:data.game,room :data.room,userId: data.userId
      console.log('Idling receiver...')
      this.viewState = 'idle'
      this.status = 'idle'
    },

    joinGame({ userId }) {
      console.log('User', userId, 'joins launched game')
      if (!this.players.includes(userId)) {
        this.players.push(userId)
      }
      if (!this.game.players.includes(userId)) {
        this.game.players.push(userId)
      }
    },

    startGame({ userId }) {
      console.log('User', userId, 'starts the game')
      this.status = 'playing'
      this.viewState = 'playing'
    },

    pauseGame({ userId }) {
      console.log('User', userId, 'pauses the game')
      this.status = 'paused'
    },

    leaveGame({ userId }) {
      console.log('User', userId, 'leaves the game')
      this.game.players = this.game.players.filter(p => p !== userId)
      this.players = this.players.filter(p => p !== userId)

            if (this.players.length === 0) {
        this.viewState = 'created'
        this.status = 'initialized'
        this.game = { id: '', players: [] }
      }
    }
  }
})
